import { Link } from "react-router-dom";
import type { Title } from "@/types";
import { typeMetaMap } from "@/lib/titles";

interface TitleCardProps {
  item: Title;
  className?: string;
}

export default function TitleCard({ item, className = "" }: TitleCardProps) {
  const typeLabel = typeMetaMap[item.type].label;

  return (
    <Link
      to={`/detail/${item.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.name} 封面`}
          title={`${item.name} 影视剧情介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2 py-1 text-xs font-bold text-primary-950">
          <i className="ri-star-fill text-[10px]" aria-hidden="true" />
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-3 right-3 rounded-md bg-primary-950/80 px-2 py-1 text-xs text-background-50">
          {typeLabel}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.name}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500">
          {item.year} · {item.region} · {item.genres.slice(0, 3).join(" / ")}
        </p>
        <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-foreground-700">{item.short}</p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-secondary-600">
          <i className="ri-play-circle-line text-sm" aria-hidden="true" />
          查看剧情介绍
        </span>
      </div>
    </Link>
  );
}